module.exports = __webpack_public_path__ + "media/images/weather/41_night-7b30acbd498769e636fc533456873915.png";